<!-- Page banner Area -->

<div class="page-banner bg-4">

    <div class="d-table">

        <div class="d-table-cell">

            <div class="container">

                <div class="page-content about-banner-content">

                    <h2>About Us</h2>

                    <ul>

                        <li><a routerLink="/">Home</a></li>

                        <li>About Us</li>

                    </ul>

                </div>

            </div>

        </div>

    </div>

</div>

<!-- End Page banner Area -->



<div class="container-fluid mt-5">We are <span
        style="font-family:sans-serif;  font-size: 23px; font-weight: bold;">lemonmode</span> We have

    been in the Online sales

    service since more than 12 Years and have

    been helping lots of

    customers in India to get products available only in International market to be delivered to them in India with

    Maximum ease and burn to their Pocket.

    We have our preferred and best business partners overseas product wise who are the best options to get the Item

    available in International not only in the most competitive price but also a genuine product. As time and again we

    have always come across cases were in building a first copy of the product or assembling is done by fraudsters and

    then selling the same sub standard product to the customer at an International Price. So, to avoid of getting a

    duplicate or fake product. We directly import the item through our well known resources in International Market and

    making it available for customers at a very competitive price.</div>







<!-- About Safe Area -->

<div class="about-text-area mt-5 mb-4 container-fluid" data-aos="fade-up" data-aos-duration="1000">

    <div class="row align-items-center">

        <div class="col-lg-6 col-md-12" data-aos="fade-right" data-aos-delay="100">

            <div class="about-contant-others">

                <div class="section-title">

                    <span class="sub-title-modern">About Us</span>

                    <div class="fs-3 text-black fw-semibold">Trusted & Faster Lemonmode Service Provider</div>

                </div>



                <div class="about-two-text">

                    <p>To fast-track the process, trucks carrying expedited goods rarely stop along the way.

                        Expedited shipments move directly from pickup to delivery. Typically, trucking

                        companies offering this rapid service will move shipments in a single truck with two

                        drive.

                    </p>

                    <ul class="list-unstyled d-grid gap-1 mb-4">

                        <li class="d-flex align-items-start gap-2">

                            <i class='bx bx-check-circle text-success fs-5 mt-1'></i>

                            <span>We provide the best logistic service worldwide</span>

                        </li>

                        <li class="d-flex align-items-start gap-2">

                            <i class='bx bx-check-circle text-success fs-5 mt-1'></i>

                            <span>All payment methods we accept for ordering our service.</span>

                        </li>

                        <li class="d-flex align-items-start gap-2">

                            <i class='bx bx-check-circle text-success fs-5 mt-1'></i>

                            <span>We provide proper safety and security.</span>

                        </li>

                    </ul>

                    <div class="about-actions">
                        <a routerLink="/contact" class="btn btn-blink">
                            <span>Contact Us</span>
                            <i class="bi bi-arrow-right"></i>
                        </a>
                        <a href="https://www.youtube.com/watch?v=XK603-FIyaA"
                            class="btn btn-blink popup-youtube">
                            <i class="bi bi-play"></i>
                            <span>Watch Our Story</span>
                        </a>
                    </div>

                </div>

            </div>

        </div>



        <div class="col-lg-6 col-md-12" data-aos="fade-left" data-aos-delay="200">

            <div class="safe-image">

                <img src="assets/img/about_1.png" alt="image">

                <div class="safe-image-badge">

                    <span class="safe-image-badge__label">Global Reach</span>

                    <strong class="safe-image-badge__value">Secure Delivery</strong>

                </div>

            </div>

        </div>

    </div>

</div>

<!-- End About Safe Area -->



<!-- About Info -->

<!-- <div class="about-info-area pb-70">

    <div class="container">

        <div class="row">

            <div class="col-lg-4 col-md-6">

                <div class="about-info-card">

                    <h3>Our Mission</h3>



                    <ul>

                        <li><i class='bx bx-check'></i> We provide best lemonmode service worldwide.</li>

                        <li><i class='bx bx-check'></i> All payment methods we accept.</li>

                        <li><i class='bx bx-check'></i> We provide proper safety and security.</li>

                        <li><i class='bx bx-check'></i> We provide best lemonmode service worldwide.</li>

                        <li><i class='bx bx-check'></i> All payment methods we accept.</li>

                        <li><i class='bx bx-check'></i> We provide proper safety and security.</li>

                    </ul>

                </div>

            </div>



            <div class="col-lg-4 col-md-6">

                <div class="about-info-card">

                    <h3>Our Promises</h3>



                    <ul>

                        <li><i class='bx bx-check'></i> We provide best lemonmode service worldwide.</li>

                        <li><i class='bx bx-check'></i> All payment methods we accept.</li>

                        <li><i class='bx bx-check'></i> We provide proper safety and security.</li>

                        <li><i class='bx bx-check'></i> We provide best lemonmode service worldwide.</li>

                        <li><i class='bx bx-check'></i> All payment methods we accept.</li>

                        <li><i class='bx bx-check'></i> We provide proper safety and security.</li>

                    </ul>

                </div>

            </div>



            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">

                <div class="about-info-card">

                    <h3>Our Vission</h3>



                    <ul>

                        <li><i class='bx bx-check'></i> We provide best lemonmode service worldwide.</li>

                        <li><i class='bx bx-check'></i> All payment methods we accept.</li>

                        <li><i class='bx bx-check'></i> We provide proper safety and security.</li>

                        <li><i class='bx bx-check'></i> We provide best lemonmode service worldwide.</li>

                        <li><i class='bx bx-check'></i> All payment methods we accept.</li>

                        <li><i class='bx bx-check'></i> We provide proper safety and security.</li>

                    </ul>

                </div>

            </div>

        </div>

    </div>

</div> -->

<!-- End About Info -->



<!-- Digital Area -->

<div class="digital-area  mt-5mb-4 container-fluid" data-aos="fade-up" data-aos-duration="1000">

    <div class="row align-items-center">

        <div class="col-lg-6 col-md-12" data-aos="fade-right" data-aos-delay="100">

            <div class="digital-image">

                <img src="assets/img/about_2.png" alt="image">

                <div class="digital-image-badge">

                    <span class="digital-image-badge__label">Fast Process</span>

                    <strong class="digital-image-badge__value">Tracked With Care</strong>

                </div>

            </div>

        </div>



        <div class="col-lg-6 col-md-12" data-aos="fade-left" data-aos-delay="200">

            <div class="about-contant-others">

                <div class="about-two-text">

                    <div class="fs-3 text-black fw-semibold">Faster, Safe and Trusted Lemonmode Services</div>

                    <p>When you have goods that need to be delivered, theres no time to waste. Especially when

                        PwCs

                        Global Consumer Insights Survey indicates that expectations for fast, flexible and

                        reliable

                        shipments are higher than ever. The good news for shippers is that shipping doesn't have

                        to

                        be hard and time constraints are exactly why you may be interested in expedited

                        shipping.

                    </p>

                    <ul>

                        <li><i class='bx bx-check'></i> Worldwide service</li>

                        <li><i class='bx bx-check'></i> 24/7 support</li>

                        <li><i class='bx bx-check'></i> Tracking service</li>

                        <li><i class='bx bx-check'></i> First and reliable</li>

                    </ul>

                    <div class="about-actions">
                        <a routerLink="/contact" class="btn btn-blink">
                            <span>Contact Us</span>
                            <i class="bi bi-arrow-right"></i>
                        </a>
                      
                    </div>

                </div>

            </div>

        </div>

        <!-- <div class="digital-card-contant">

                    <div class="row">

                        <div class="col-lg-6 col-md-12">

                            <div class="digital-card">

                                <div class="card-text">

                                    <i class='bx bx-cart-alt'></i>

                                    <h3><span>1998</span> - Company Started</h3>

                                    <p>orem ipsum dolor sit amet elit, sed do eiusmod tempor incididunt ut labore et .</p>

                                </div>

                            </div>

                        </div>

        

                        <div class="col-lg-6 col-md-12">

                            <div class="digital-card">

                                <div class="card-text">

                                    <i class='bx bx-map-alt'></i>

                                    <h3><span>2008</span> - Office worldwide</h3>

                                    <p>orem ipsum dolor sit amet elit, sed do eiusmod tempor incididunt ut labore et .</p>

                                </div>

                            </div>

                        </div>

        

                        <div class="col-lg-6 col-md-12">

                            <div class="digital-card">

                                <div class="card-text">

                                    <i class='bx bxs-truck'></i>

                                    <h3><span>2004</span> - Vehicles Adding</h3>

                                    <p>orem ipsum dolor sit amet elit, sed do eiusmod tempor incididunt ut labore et .</p>

                                </div>

                            </div>

                        </div>

        

                        <div class="col-lg-6 col-md-12">

                            <div class="digital-card">

                                <div class="card-text">

                                    <i class='bx bx-award'></i>

                                    <h3><span>2012</span> - Award Of The Year Won</h3>

                                    <p>orem ipsum dolor sit amet elit, sed do eiusmod tempor incididunt ut labore et .</p>

                                </div>

                            </div>

                        </div>

                    </div>

                </div> -->

    </div>

</div>

<!-- End Digital Area -->



<!-- Statistics Counter Section -->

<section class="stats-section  mt-5 pb-5 bg-white container-fluid" data-aos="fade-up" data-aos-duration="1000">

    <div class="container">

        <div class="text-center mb-5" data-aos="zoom-in" data-aos-delay="100">

            <span class="sub-title-modern">Our Achievements</span>

            <div class="fs-3 text-black fw-semibold">Numbers That Speak Excellence</div>

        </div>

        <div class="row g-4">

            <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="100">

                <div class="stat-box text-center p-4 bg-white rounded-3 shadow-sm">

                    <div class="stat-icon mb-3">

                        <i class="bi bi-globe fs-1 text-primary"></i>

                    </div>

                    <h3 class="stat-number fs-2 fw-bold text-primary mb-2">

                        <span class="counter" data-count="120">0</span>+

                    </h3>

                    <p class="stat-label text-muted mb-0">Countries Served</p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="200">

                <div class="stat-box text-center p-4 bg-white rounded-3 shadow-sm">

                    <div class="stat-icon mb-3">

                        <i class="bi bi-people fs-1 text-success"></i>

                    </div>

                    <h3 class="stat-number fs-2 fw-bold text-success mb-2">

                        <span class="counter" data-count="5000">0</span>+

                    </h3>

                    <p class="stat-label text-muted mb-0">Happy Clients</p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="300">

                <div class="stat-box text-center p-4 bg-white rounded-3 shadow-sm">

                    <div class="stat-icon mb-3">

                        <i class="bi bi-truck fs-1 text-info"></i>

                    </div>

                    <h3 class="stat-number fs-2 fw-bold text-info mb-2">

                        <span class="counter" data-count="25000">0</span>+

                    </h3>

                    <p class="stat-label text-muted mb-0">Deliveries Completed</p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="400">

                <div class="stat-box text-center p-4 bg-white rounded-3 shadow-sm">

                    <div class="stat-icon mb-3">

                        <i class="bi bi-star fs-1 text-warning"></i>

                    </div>

                    <h3 class="stat-number fs-2 fw-bold text-warning mb-2">

                        <span class="counter" data-count="98">0</span>%

                    </h3>

                    <p class="stat-label text-muted mb-0">Success Rate</p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- End Statistics Counter Section -->



<!-- Company Values Section -->

<section class="values-section py-5 container-fluid" data-aos="fade-up" data-aos-duration="1000">

    <div class="text-center mb-5" data-aos="zoom-in" data-aos-delay="100">

        <span class="sub-title-modern">Our Core Values</span>

        <div class="fs-3 text-black fw-semibold">What Drives Us Forward</div>

        <p class="lead text-muted mt-3">Our foundation is built on principles that guide every decision we make</p>

    </div>

    <div class="row g-3">

        <div class="col-lg-2 col-md-4 col-6" data-aos="fade-up" data-aos-delay="100">

            <div
                class="value-card h-100 p-3 bg-white rounded-2 shadow-sm border-start border-3 border-primary text-center">

                <div class="value-icon mb-2">

                    <i class="bi bi-shield-check fs-3 text-primary"></i>

                </div>

                <h5 class="value-title fw-bold mb-2 fs-6">Trust & Integrity</h5>

                <p class="value-text text-muted mb-0 small">Transparent business practices with highest ethical

                    standards.</p>

            </div>

        </div>

        <div class="col-lg-2 col-md-4 col-6" data-aos="fade-up" data-aos-delay="200">

            <div
                class="value-card h-100 p-3 bg-white rounded-2 shadow-sm border-start border-3 border-success text-center">

                <div class="value-icon mb-2">

                    <i class="bi bi-lightning-charge fs-3 text-success"></i>

                </div>

                <h5 class="value-title fw-bold mb-2 fs-6">Speed & Efficiency</h5>

                <p class="value-text text-muted mb-0 small">Rapid response times and streamlined processes.</p>

            </div>

        </div>

        <div class="col-lg-2 col-md-4 col-6" data-aos="fade-up" data-aos-delay="300">

            <div
                class="value-card h-100 p-3 bg-white rounded-2 shadow-sm border-start border-3 border-info text-center">

                <div class="value-icon mb-2">

                    <i class="bi bi-award fs-3 text-info"></i>

                </div>

                <h5 class="value-title fw-bold mb-2 fs-6">Quality Excellence</h5>

                <p class="value-text text-muted mb-0 small">Never compromise on quality and attention to detail.</p>

            </div>

        </div>

        <div class="col-lg-2 col-md-4 col-6" data-aos="fade-up" data-aos-delay="400">

            <div
                class="value-card h-100 p-3 bg-white rounded-2 shadow-sm border-start border-3 border-warning text-center">

                <div class="value-icon mb-2">

                    <i class="bi bi-headset fs-3 text-warning"></i>

                </div>

                <h5 class="value-title fw-bold mb-2 fs-6">Customer First</h5>

                <p class="value-text text-muted mb-0 small">Customers at the heart of everything we do daily.</p>

            </div>

        </div>

        <div class="col-lg-2 col-md-4 col-6" data-aos="fade-up" data-aos-delay="500">

            <div
                class="value-card h-100 p-3 bg-white rounded-2 shadow-sm border-start border-3 border-danger text-center">

                <div class="value-icon mb-2">

                    <i class="bi bi-globe2 fs-3 text-danger"></i>

                </div>

                <h5 class="value-title fw-bold mb-2 fs-6">Global Reach</h5>

                <p class="value-text text-muted mb-0 small">Extensive network spanning 120+ countries.</p>

            </div>

        </div>

        <div class="col-lg-2 col-md-4 col-6" data-aos="fade-up" data-aos-delay="600">

            <div
                class="value-card h-100 p-3 bg-white rounded-2 shadow-sm border-start border-3 border-dark text-center">

                <div class="value-icon mb-2">

                    <i class="bi bi-recycle fs-3 text-dark"></i>

                </div>

                <h5 class="value-title fw-bold mb-2 fs-6">Sustainability</h5>

                <p class="value-text text-muted mb-0 small">Eco-friendly practices and reduced carbon footprint.</p>

            </div>

        </div>

    </div>

</section>

<!-- End Company Values Section -->



<!-- Call to Action Section -->

<section class="cta-section py-5 bg-dark text-white container-fluid" data-aos="fade-up" data-aos-duration="1000">

    <div class="row align-items-center">

        <div class="col-lg-8" data-aos="fade-right" data-aos-delay="100">

            <h2 class="fs-2 text-white fw-bold mb-3">Ready to Experience World-Class Logistics?</h2>

            <p class="lead mb-0" style="color: rgba(255,255,255,0.9);">Join thousands of satisfied customers who trust
                Lemonmode for their shipping

                needs. Get started today and see the difference.</p>

        </div>

        <div class="col-lg-4 text-lg-end" data-aos="fade-left" data-aos-delay="200">

            <a routerLink="/contact" class="btn btn-primary px-4 py-2 rounded-pill">

                Get Started Now

                <i class="bi bi-arrow-right ms-2"></i>

            </a>

        </div>

    </div>

</section>

<!-- End Call to Action Section -->



<!-- Partners Section -->

<section class="py-5 bg-white" data-aos="fade-up" data-aos-duration="1000">

    <div class="container text-center mb-5" data-aos="zoom-in" data-aos-delay="100">

        <span class="sub-title-modern">Our Partners</span>

        <div class="fs-3 text-black fw-semibold">Trusted by Industry Leaders</div>

        <p class="lead text-muted mt-3">Seamless integrations with top marketplaces worldwide</p>

    </div>



    <div class="container-fluid px-3 px-md-4">

        <div class="d-flex flex-wrap justify-content-center gap-3">

            <a href="https://www.amazon.com/" target="_blank"
                class="d-flex align-items-center justify-content-center p-2 bg-white rounded-3 shadow-sm"
                style="min-width: 120px; height: 70px;">

                <img src="assets/img/market_logo_1.jpg" alt="Amazon" class="img-fluid" style="max-height: 40px;">

            </a>

            <a href="https://www.ebay.com/" target="_blank"
                class="d-flex align-items-center justify-content-center p-2 bg-white rounded-3 shadow-sm"
                style="min-width: 120px; height: 70px;">

                <img src="assets/img/market_logo9.jpg" alt="eBay" class="img-fluid" style="max-height: 40px;">

            </a>

            <a href="https://www.walmart.com/" target="_blank"
                class="d-flex align-items-center justify-content-center p-2 bg-white rounded-3 shadow-sm"
                style="min-width: 120px; height: 70px;">

                <img src="assets/img/market_logo5.jpg" alt="Walmart" class="img-fluid" style="max-height: 40px;">

            </a>

            <a href="https://www.newegg.com/" target="_blank"
                class="d-flex align-items-center justify-content-center p-2 bg-white rounded-3 shadow-sm"
                style="min-width: 120px; height: 70px;">

                <img src="assets/img/market_logo2.jpg" alt="Newegg" class="img-fluid" style="max-height: 40px;">

            </a>

            <a href="https://www.wish.com/" target="_blank"
                class="d-flex align-items-center justify-content-center p-2 bg-white rounded-3 shadow-sm"
                style="min-width: 120px; height: 70px;">

                <img src="assets/img/market_logo3-1.jpg" alt="Wish" class="img-fluid" style="max-height: 40px;">

            </a>

            <a href="https://www.houzz.com/" target="_blank"
                class="d-flex align-items-center justify-content-center p-2 bg-white rounded-3 shadow-sm"
                style="min-width: 120px; height: 70px;">

                <img src="assets/img/market_logo7.jpg" alt="Houzz" class="img-fluid" style="max-height: 40px;">

            </a>

            <a href="https://www.textbookrush.com/" target="_blank"
                class="d-flex align-items-center justify-content-center p-2 bg-white rounded-3 shadow-sm"
                style="min-width: 120px; height: 70px;">

                <img src="assets/img/market_logo4-1.jpg" alt="TextbookRush" class="img-fluid" style="max-height: 40px;">

            </a>

            <a href="https://www.valore.com/" target="_blank"
                class="d-flex align-items-center justify-content-center p-2 bg-white rounded-3 shadow-sm"
                style="min-width: 120px; height: 70px;">

                <img src="assets/img/market_logo11-1.jpg" alt="Valore" class="img-fluid" style="max-height: 40px;">

            </a>

        </div>

    </div>

</section>

<!-- End Partners Section -->



<!-- Newsletter Area -->

<div class="newsletter-area">

    <div class="container">

        <div class="newsletter-content">

            <div class="row align-items-center">

                <!-- <div class="col-lg-5 col-md-12">

                    <div class="newsletter-title">

                        <h3>Subscribe to our newsletter:</h3>

                        <p>Focused on the transport and lemonmode industry</p>

                    </div>

                </div>



                <div class="col-lg-7 col-md-12">

                    <div class="newsletter-form">

                        <form>

                            <input type="email" class="form-control" placeholder="Email Address" required

                                autocomplete="off">

                            <button type="submit" class="btn btn-primary">Subscribe</button>

                        </form>

                    </div>

                </div> -->

            </div>

        </div>

    </div>

</div>

<!-- End Newsletter Area -->